var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFerrariHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29443",
    "data-name": "Group 29443",
    transform: "translate(-153.999 -662.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(153.999 662.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-ferrari",
    transform: "translate(172.521 670.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50567",
    "data-name": "Path 50567",
    d: "M16,2,8,3.5V10a17.139,17.139,0,0,0,8,14Zm0,0,8,1.5V10a17.139,17.139,0,0,1-8,14Z",
    transform: "translate(-8 -2)",
    fill: "#ed1b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50568",
    "data-name": "Path 50568",
    d: "M32,3.5v1L24,3V2ZM32,10Z",
    transform: "translate(-16.002 -2)",
    fill: "#009a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50569",
    "data-name": "Path 50569",
    d: "M16.5,27.4A16.719,16.719,0,0,1,9,14V11.35A20.47,20.47,0,0,1,16.5,10,21.349,21.349,0,0,1,24,11.35V14C24,14.1,24,22.6,16.5,27.4Z",
    transform: "translate(-8.5 -6.001)",
    fill: "#fef200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50570",
    "data-name": "Path 50570",
    d: "M16,10a20.544,20.544,0,0,1,7,1.2v2.3a16.222,16.222,0,0,1-7,12.8A16.043,16.043,0,0,1,9,13.5V11.2A21.075,21.075,0,0,1,16,10m0-1a19.756,19.756,0,0,0-8,1.55H8V13.5a17.139,17.139,0,0,0,8,14,17.139,17.139,0,0,0,8-14V10.55h0A20.026,20.026,0,0,0,16,9Z",
    transform: "translate(-8 -5.501)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50571",
    "data-name": "Path 50571",
    d: "M8,3.5v1L16,3V2ZM8,10Z",
    transform: "translate(-8 -2)",
    fill: "#009a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50572",
    "data-name": "Path 50572",
    d: "M8,5.5v1L16,5V4Zm0,6.448ZM24,5.5v1L16,5V4Zm0,6.448Z",
    transform: "translate(-8 -3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50573",
    "data-name": "Path 50573",
    d: "M24.711,19.549a3.054,3.054,0,0,1,.3-1.2s-.5.3-.55.7c-.2-.4.15-1,.15-1-.2.1-.45.3-.45,1,0,1.8-.05,1.7-.2,2-.05.05-.2.05-.15-.1-.05-.2.05-.65-1.15-1.35-.55-.35-.85-.9-.75-1.15a1.116,1.116,0,0,0,.7.15,2.9,2.9,0,0,1-.6-.5,1.7,1.7,0,0,0,1,.15,2.255,2.255,0,0,1-.9-.7,1.3,1.3,0,0,0,.9.1c-.25-.1-.65-.3-.75-.6a1.525,1.525,0,0,0,.85,0,2,2,0,0,1-.85-.65,1.9,1.9,0,0,1,.85.2c-.1-.3-.55-.55-.9-.8a3.238,3.238,0,0,0,.7,0c-.2-.2-.65-.4-.7-.5a.744.744,0,0,0,.45-.2c-.65,0-.75-.5-1-.5-.1-.05-.25-.4-.3-.5a.666.666,0,0,0-.2.5c-.6,0-.65.35-.8.45-.75.3-.85.1-1.05.3a.432.432,0,0,0-.15.3c-.05.25.05.45.35.45.1,0,.3-.15.45-.15.25,0,.5.25.9.25.15,0,.3-.1.55-.5-.1.55-.25.75-.7.75a4.729,4.729,0,0,1-.75,1.9,2.472,2.472,0,0,1-1.25.6c-.05.05-.4,0-.45.15a.689.689,0,0,0,0,.45,4.834,4.834,0,0,0,.25,1.05.223.223,0,0,0,.15.2c.1.05.1.1.1.1a1.286,1.286,0,0,0,.3.75s.5-.6.4-.8c-.05-.1-.35-.2-.35-.2v-.2a3.535,3.535,0,0,1-.25-.8h.85a5.148,5.148,0,0,0,1.6,1.6.937.937,0,0,1,.8-.35c-1,.1-1,1.2-.75,1.65.35.7.35.85.3,1-.25.4-.3.45-.4.6-.05.1.05.15-.05.2a1.114,1.114,0,0,0-.6.65s.85.1,1-.05c.05-.05.05-.3.05-.3a2.165,2.165,0,0,0,.25.05c.05-.05.15-.05.15-.1s.1-.25.1-.3a1.882,1.882,0,0,1,.45-.75c0-.05-.25-.35-.25-.5-.05-.65.5-.6,1.2-1.45.05-.1.15-.05.2-.05,1.3,0,1.15-1.05,1.35-2.2C24.711,19.8,24.711,19.549,24.711,19.549Z",
    transform: "translate(-13.114 -8.052)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28986",
    "data-name": "Group 28986",
    transform: "translate(5.599 13.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50574",
    "data-name": "Path 50574",
    d: "M20.4,30.549c.05,0,.15.05.2,0a.666.666,0,0,1,.25-.15,2.631,2.631,0,0,1,.9-.2.331.331,0,0,0,.05-.3,1.516,1.516,0,0,1-.25-1.45c-.05-.05-.35-.3-.4-.35a7.889,7.889,0,0,1-.05,1.45c-.45.15-.7-.05-.9,0-.1.05-.05.15-.15.1a.978.978,0,0,0-.85.2s.6.7.8.65c.05,0,.25-.2.25-.2S20.3,30.5,20.4,30.549Z",
    transform: "translate(-19.2 -28.1)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50575",
    "data-name": "Path 50575",
    d: "M16.9,21.1a1,1,0,0,0,.15-.4s.15,0,.2-.05l.15-.15c.15-.15.45-.4.45-.4.1.1.4.5.55.7a1.362,1.362,0,0,0,.5-.55c-.35-.4-.75-.95-1-.95a6.837,6.837,0,0,0-1.1.95.387.387,0,0,0-.05.15,1.052,1.052,0,0,0-.65.45S16.75,21.25,16.9,21.1Z",
    transform: "translate(-12.051 -10.652)",
    fill: "#37474f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerrariHighlighted);
export default __webpack_public_path__ + "static/media/FerrariHighlighted.554c0d27b8db84ae7ce44ccb3057782e.svg";
export { ForwardRef as ReactComponent };